import { render } from "./property-popmap.vue?vue&type=template&id=494c17d4"
import script from "./property-popmap.js?vue&type=script&lang=js"
export * from "./property-popmap.js?vue&type=script&lang=js"

import "./property-popmap.vue?vue&type=style&index=0&id=494c17d4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__